module.exports = __webpack_public_path__ + "img/twitter.8615deb2.svg";